const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

export const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.status === 204 ? null : response.json();
  }
  const body = await response.json().catch(() => ({}));
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      return;
    }
    query.append(key, value);
  });
  return query.toString();
};

export async function listSectorRatios(params = {}) {
  const query = buildQuery(params);
  const response = await fetch(`${API_BASE}/api/sector-ratios${query ? `?${query}` : ''}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Sektor rasyolari alinamadi.');
}

export async function createSectorRatio(payload) {
  const response = await fetch(`${API_BASE}/api/sector-ratios`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(payload)
  });
  return handleErrors(response, 'Sektor rasyosu olusturulamadi.');
}

export async function updateSectorRatio(id, payload) {
  const response = await fetch(`${API_BASE}/api/sector-ratios/${id}`, {
    method: 'PUT',
    headers: buildHeaders(),
    body: JSON.stringify(payload)
  });
  return handleErrors(response, 'Sektor rasyosu guncellenemedi.');
}

export async function deleteSectorRatio(id) {
  const response = await fetch(`${API_BASE}/api/sector-ratios/${id}`, {
    method: 'DELETE',
    headers: buildHeaders()
  });
  return handleErrors(response, 'Sektor rasyosu silinemedi.');
}

export async function importSectorRatiosFromEvds() {
  const response = await fetch(`${API_BASE}/api/sector-ratios/import-evds`, {
    method: 'POST',
    headers: buildHeaders()
  });
  return handleErrors(response, "Sektor rasyolari EVDS'den alinamadi.");
}

export async function clearSectorRatios({ periodId, sectorId, ratioId, includeOrphanPeriods = true }) {
  const query = buildQuery({ periodId, sectorId, ratioId, includeOrphanPeriods });
  const response = await fetch(`${API_BASE}/api/sector-ratios/clear?${query}`, {
    method: 'POST',
    headers: buildHeaders()
  });
  return handleErrors(response, 'Sektor rasyolari temizlenemedi.');
}

const sectorRatiosService = {
  listSectorRatios,
  createSectorRatio,
  updateSectorRatio,
  deleteSectorRatio,
  importSectorRatiosFromEvds,
  clearSectorRatios
};

export default sectorRatiosService;
